import React from 'react'

import { Form, Col } from '_zari/core'

const TipoDocumentoFormGroup = ({ value }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO DOCUMENTO' htmlFor='input-tipoDocumento-2' md={4} />
      <Col md={8}>
        <Form.InputText value={value} disabled id='input-tipoDocumento-2' />
      </Col>
    </Form.Group>
  )
}

export default TipoDocumentoFormGroup
